import { Button, Checkbox, Col, InputNumber, Row, Space, Typography } from 'antd';
import React, { FC, useCallback, useEffect, useState } from 'react';
const { Text } = Typography;

export type Props = {
  onChange?: (value: any) => void;
  values?: any[];
};

export interface ValueType {
  weight: number;
  percentage: number;
  checked: boolean;
}

const Configurations: FC<Props> = (props) => {
  const [supervisor, setSupervisor] = useState<ValueType>({
    weight: 0,
    percentage: 0,
    checked: false,
  });
  const [peer, setPeer] = useState<ValueType>({
    weight: 0,
    percentage: 0,
    checked: false,
  });
  const [internal, setInternal] = useState<ValueType>({
    weight: 0,
    percentage: 0,
    checked: false,
  });
  const [team, setTeam] = useState<ValueType>({
    weight: 0,
    percentage: 0,
    checked: false,
  });

  const [data, setData] = useState<any>();
  const [changed, setChanged] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [percentage, setPercentage] = useState<number[]>([0, 0, 0, 0]);

  useEffect(() => {
    if (props.values) {
      let sum = 0;
      for (const item of props?.values) {
        delete item.id;
        delete item.goalSummeryId;
        if (item.type === 'internalCustomer') setInternal({ ...item, weight: +item.weight });
        else if (item.type === 'supervisorFeedBack')
          setSupervisor({ ...item, weight: +item.weight });
        else if (item.type === 'peerReview') setPeer({ ...item, weight: +item.weight });
        else setTeam({ ...item, weight: +item.weight });
        sum += +item.weight;
      }
      const data = {
        supervisorFeedBack: {
          ...props?.values.find((item) => item.type === 'supervisorFeedBack'),
          weight: +props?.values.find((item) => item.type === 'supervisorFeedBack')?.weight ?? 0,
          percentage: Math.round(
            ((+props?.values.find((item) => item.type === 'supervisorFeedBack')?.weight ?? 0) /
              sum) *
              100,
          ),
        },
        peerReview: {
          ...props?.values.find((item) => item.type === 'peerReview'),
          weight: +props?.values.find((item) => item.type === 'peerReview')?.weight ?? 0,
          percentage: Math.round(
            ((+props?.values.find((item) => item.type === 'peerReview')?.weight ?? 0) / sum) * 100,
          ),
        },
        internalCustomer: {
          ...props?.values.find((item) => item.type === 'internalCustomer'),
          weight: +props?.values.find((item) => item.type === 'internalCustomer')?.weight ?? 0,
          percentage: Math.round(
            ((+props?.values.find((item) => item.type === 'internalCustomer')?.weight ?? 0) / sum) *
              100,
          ),
        },
        teamPerformance: {
          ...props?.values.find((item) => item.type === 'teamPerformance'),
          weight: +props?.values.find((item) => item.type === 'teamPerformance')?.weight ?? 0,
          percentage: Math.round(
            ((+props?.values.find((item) => item.type === 'teamPerformance')?.weight ?? 0) / sum) *
              100,
          ),
        },
      };
      setPercentage([
        Math.round(
          ((+props?.values.find((item) => item.type === 'supervisorFeedBack')?.weight ?? 0) / sum) *
            100,
        ),
        Math.round(
          ((+props?.values.find((item) => item.type === 'peerReview')?.weight ?? 0) / sum) * 100,
        ),
        Math.round(
          ((+props?.values.find((item) => item.type === 'internalCustomer')?.weight ?? 0) / sum) *
            100,
        ),
        Math.round(
          ((+props?.values.find((item) => item.type === 'teamPerformance')?.weight ?? 0) / sum) *
            100,
        ),
      ]);
      setData(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.values]);

  const submitChange = useCallback(
    (data: any) => {
      props.onChange?.(data);
    },
    [props],
  );

  const calculatePercentageAndSubmit = useCallback(() => {
    setLoading(true);
    const sum = +supervisor.weight + +peer.weight + +internal.weight + +team.weight;
    setSupervisor({ ...supervisor, percentage: Math.round((+supervisor.weight / sum) * 100) });
    setPeer({ ...peer, percentage: Math.round((+peer.weight / sum) * 100) });
    setInternal({ ...internal, percentage: Math.round((+internal.weight / sum) * 100) });
    setTeam({ ...team, percentage: Math.round((+team.weight / sum) * 100) });
    const data = {
      supervisorFeedBack: {
        ...supervisor,
        percentage: Math.round((+supervisor.weight / sum) * 100),
      },
      peerReview: { ...peer, percentage: Math.round((+peer.weight / sum) * 100) },
      internalCustomer: { ...internal, percentage: Math.round((+internal.weight / sum) * 100) },
      teamPerformance: { ...team, percentage: Math.round((+team.weight / sum) * 100) },
    };
    submitChange(data);
    setLoading(false);
  }, [internal, peer, submitChange, supervisor, team]);

  const calculatePercentage = useCallback(
    (x: {
      supervisorFeedBack: number;
      peerReview: number;
      internalCustomer: number;
      teamPerformance: number;
    }) => {
      const sum = +x.supervisorFeedBack + +x.peerReview + +x.internalCustomer + +x.teamPerformance;
      setPercentage([
        Math.round((+x.supervisorFeedBack / sum) * 100),
        Math.round((+x.peerReview / sum) * 100),
        Math.round((+x.internalCustomer / sum) * 100),
        Math.round((+x.teamPerformance / sum) * 100),
      ]);
      // setPeer({ ...peer, percentage: Math.round((+peer.weight / sum) * 100) });
      // setInternal({ ...internal, percentage: Math.round((+internal.weight / sum) * 100) });
      // setTeam({ ...team, percentage: Math.round((+team.weight / sum) * 100) });
      const data1 = {
        supervisorFeedBack: {
          ...supervisor,
          percentage: Math.round((+x.supervisorFeedBack / sum) * 100),
        },
        peerReview: { ...peer, percentage: Math.round((+x.peerReview / sum) * 100) },
        internalCustomer: {
          ...internal,
          percentage: Math.round((+x.internalCustomer / sum) * 100),
        },
        teamPerformance: { ...team, percentage: Math.round((+x.teamPerformance / sum) * 100) },
      };
      console.log(changed);
      setChanged(
        data.supervisorFeedBack.weight !== data1.supervisorFeedBack.weight ||
          data.supervisorFeedBack.checked !== data1.supervisorFeedBack.checked ||
          data.peerReview.weight !== data1.peerReview.weight ||
          data.peerReview.checked !== data1.peerReview.checked ||
          data.internalCustomer.weight !== data1.internalCustomer.weight ||
          data.internalCustomer.checked !== data1.internalCustomer.checked ||
          data.teamPerformance.weight !== data1.teamPerformance.weight ||
          data.teamPerformance.checked !== data1.teamPerformance.checked,
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, internal, peer, supervisor, team],
  );

  return (
    <Col>
      <Row style={{ marginBottom: 10 }}>
        <Space size={20}>
          <Row style={{ width: 300 }}>
            <div style={{ width: 150 }}>
              <Text>Supervisor Feedback</Text>
            </div>
            <Checkbox
              checked={supervisor.checked}
              onChange={(e) => {
                if (e.target.checked) {
                  setSupervisor({ ...supervisor, checked: e.target.checked });
                  calculatePercentage({
                    supervisorFeedBack: +supervisor.weight,
                    peerReview: +peer.weight,
                    internalCustomer: +internal.weight,
                    teamPerformance: +team.weight,
                  });
                } else {
                  setSupervisor({ weight: 0, percentage: 0, checked: e.target.checked });
                  calculatePercentage({
                    supervisorFeedBack: 0,
                    peerReview: +peer.weight,
                    internalCustomer: +internal.weight,
                    teamPerformance: +team.weight,
                  });
                }
              }}
              // onMouseLeave={() => calculatePercentage()}
            />
          </Row>
          <InputNumber
            value={supervisor.weight}
            onChange={(e) => {
              setSupervisor({ ...supervisor, weight: e ?? 0 });
              calculatePercentage({
                supervisorFeedBack: e ?? 0,
                peerReview: +peer.weight,
                internalCustomer: +internal.weight,
                teamPerformance: +team.weight,
              });
            }}
            disabled={!supervisor.checked}
            // onBlur={() => calculatePercentage()}
          />
          <Text>{`${isNaN(percentage[0]) ? 0 : percentage[0]}%`}</Text>
        </Space>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Space size={20}>
          <Row style={{ width: 300 }}>
            <div style={{ width: 150 }}>
              <Text>Peer Review</Text>
            </div>
            <Checkbox
              checked={peer.checked}
              onChange={(e) => {
                if (e.target.checked) {
                  setPeer({ ...peer, checked: e.target.checked });
                  calculatePercentage({
                    supervisorFeedBack: +supervisor.weight ?? 0,
                    peerReview: +peer.weight,
                    internalCustomer: +internal.weight,
                    teamPerformance: +team.weight,
                  });
                } else {
                  setPeer({ weight: 0, percentage: 0, checked: e.target.checked });
                  calculatePercentage({
                    supervisorFeedBack: +supervisor.weight ?? 0,
                    peerReview: 0,
                    internalCustomer: +internal.weight,
                    teamPerformance: +team.weight,
                  });
                }
              }}
              // onMouseLeave={() => calculatePercentage()}
            />
          </Row>
          <InputNumber
            value={peer.weight}
            onChange={(e) => {
              setPeer({ ...peer, weight: e ?? 0 });
              calculatePercentage({
                supervisorFeedBack: +supervisor.weight ?? 0,
                peerReview: e ?? 0,
                internalCustomer: +internal.weight,
                teamPerformance: +team.weight,
              });
            }}
            disabled={!peer.checked}
            // onBlur={() => calculatePercentage()}
          />
          <Text>{`${isNaN(percentage[1]) ? 0 : percentage[1]}%`}</Text>
        </Space>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Space size={20}>
          <Row style={{ width: 300 }}>
            <div style={{ width: 150 }}>
              <Text>Internal Customer</Text>
            </div>
            <Checkbox
              checked={internal.checked}
              onChange={(e) => {
                if (e.target.checked) {
                  setInternal({ ...internal, checked: e.target.checked });
                  calculatePercentage({
                    supervisorFeedBack: +supervisor.weight ?? 0,
                    peerReview: +peer.weight,
                    internalCustomer: +internal.weight,
                    teamPerformance: +team.weight,
                  });
                } else {
                  setInternal({ weight: 0, percentage: 0, checked: e.target.checked });
                  calculatePercentage({
                    supervisorFeedBack: +supervisor.weight ?? 0,
                    peerReview: +peer.weight,
                    internalCustomer: 0,
                    teamPerformance: +team.weight,
                  });
                }
              }}
              // onMouseLeave={() => calculatePercentage()}
            />
          </Row>
          <InputNumber
            value={internal.weight}
            onChange={(e) => {
              setInternal({ ...internal, weight: e ?? 0 });
              calculatePercentage({
                supervisorFeedBack: +supervisor.weight ?? 0,
                peerReview: +peer.weight,
                internalCustomer: e ?? 0,
                teamPerformance: +team.weight,
              });
            }}
            disabled={!internal.checked}
            // onBlur={() => calculatePercentage()}
          />
          <Text>{`${isNaN(percentage[2]) ? 0 : percentage[2]}%`}</Text>
        </Space>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Space size={20}>
          <Row style={{ width: 300 }}>
            <div style={{ width: 150 }}>
              <Text>Team Performance</Text>
            </div>
            <Checkbox
              checked={team.checked}
              onChange={(e) => {
                if (e.target.checked) {
                  setTeam({ ...team, checked: e.target.checked });
                  calculatePercentage({
                    supervisorFeedBack: +supervisor.weight ?? 0,
                    peerReview: +peer.weight,
                    internalCustomer: +internal.weight,
                    teamPerformance: +team.weight,
                  });
                } else {
                  setTeam({ weight: 0, percentage: 0, checked: e.target.checked });
                  calculatePercentage({
                    supervisorFeedBack: +supervisor.weight ?? 0,
                    peerReview: +peer.weight,
                    internalCustomer: +internal.weight,
                    teamPerformance: 0,
                  });
                }
              }}
              // onMouseLeave={() => calculatePercentage()}
            />
          </Row>
          <InputNumber
            value={team.weight}
            onChange={(e) => {
              setTeam({ ...team, weight: e ?? 0 });
              calculatePercentage({
                supervisorFeedBack: +supervisor.weight ?? 0,
                peerReview: +peer.weight,
                internalCustomer: +internal.weight,
                teamPerformance: e ?? 0,
              });
            }}
            disabled={!team.checked}
            // onBlur={() => calculatePercentage()}
          />
          <Text>{`${isNaN(percentage[3]) ? 0 : percentage[3]}%`}</Text>
        </Space>
      </Row>
      <Row style={{ marginBottom: 10 }}>
        <Space size={20}>
          <Button type={'primary'} loading={loading} onClick={calculatePercentageAndSubmit}>
            Update Components Configuration
          </Button>
        </Space>
      </Row>
    </Col>
  );
};

export default Configurations;
